"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export default function ProfileHomeSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-6">
      <Card className="rounded-xl border border-border bg-black/5 dark:bg-white/10 shadow-sm">
        <CardContent className="p-0">
          {/* Banner */}
          <div className="relative w-full h-48 md:h-56 rounded-t-xl overflow-hidden">
            <div className="absolute inset-0 skeleton" />
          </div>

          <div className="p-4 md:p-5 space-y-4">
            {/* Avatar + quick info + edit */}
            <div className="flex items-start md:items-center justify-between gap-4">
              <div className="flex items-end gap-4">
                <div className="h-20 w-20 md:h-24 md:w-24 rounded-full skeleton border-2" />
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <div className="h-5 w-40 skeleton rounded" />
                    <div className="h-4 w-16 skeleton rounded-full" />
                  </div>
                  <div className="h-4 w-24 skeleton rounded" />
                </div>
              </div>
              <div className="h-9 w-28 rounded-md skeleton" />
            </div>

            {/* Body / Contact & Social sections */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mb-2">
              <section className="rounded-lg p-3 bg-black/5 dark:bg-white/10 space-y-2">
                <div className="h-3 w-16 skeleton rounded" />
                <div className="flex flex-wrap gap-2">
                  {Array.from({ length: 7 }).map((_, i) => (
                    <span key={i} className="h-6 w-24 rounded-full skeleton" />
                  ))}
                </div>
                <div className="h-10 skeleton rounded" />
              </section>
              <section className="rounded-lg p-3 bg-yellow-50 dark:bg-zinc-800/60 space-y-2">
                <div className="h-3 w-28 skeleton rounded" />
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="h-4 w-40 skeleton rounded" />
                ))}
              </section>
            </div>

            {/* Stats row */}
            <div className="grid grid-cols-3 gap-3 mb-2">
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="flex items-center gap-3 rounded-lg bg-black/5 dark:bg-white/10 px-3 py-2">
                  <div className="h-5 w-5 rounded skeleton" />
                  <div>
                    <div className="h-3 w-12 skeleton rounded" />
                    <div className="h-4 w-10 skeleton rounded mt-1" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
